import React from 'react';

const posts = [
  { id: 1, title: '5 Tips voor je eerste kamer', date: '28 Mrt 2026', excerpt: 'Alles wat je moet weten over het vinden en inrichten van je eerste studentenkamer.' },
  { id: 2, title: 'Studiefinanciering 2026: wat verandert er?', date: '25 Mrt 2026', excerpt: 'De nieuwe regels voor studiefinanciering en hoe ze jou beïnvloeden.' },
  { id: 3, title: 'Bijbanen voor studenten: top 10', date: '20 Mrt 2026', excerpt: 'De best betaalde en flexibelste bijbanen naast je studie.' },
  { id: 4, title: 'Gezond eten op studentbudget', date: '15 Mrt 2026', excerpt: 'Lekker en gezond koken voor minder dan €3 per maaltijd.' },
];

export default function BlogPage() {
  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-5xl font-bold text-center mb-12 text-gray-800">Blog</h1>
      <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
        {posts.map(post => (
          <article key={post.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition">
            <img src={`https://picsum.photos/seed/blog${post.id}/400/200`} alt={post.title} className="w-full h-48 object-cover" />
            <div className="p-6">
              <div className="text-sm text-gray-500 mb-2">{post.date}</div>
              <h3 className="text-xl font-bold mb-3">{post.title}</h3>
              <p className="text-gray-600 mb-4">{post.excerpt}</p>
              <button className="text-blue-600 font-semibold hover:text-blue-800">Lees meer →</button>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
